import React, { useState, useRef } from "react";
import { useUserContext } from "src/contexts/userContext";
import * as API from "src/api/request";

import Sidebar from "src/components/layout/sidebar";
import Header from "src/components/layout/header";
import Breadcrumb from "src/components/layout/breadcrumb";
import ScrollButtons from "src/components/layout/scrollButtons";
// ХАБЭА туслах — дэлгэцийн доорх чат, бүх хуудсанд (2026-11-04)
import AssistantChat from "src/components/assistant/AssistantChat";
// Бүх хуудасны хүснэгтэд «Үйлдэл» баганыг баруун захад түгжинэ
import "src/components/layout/stickyActions.css";
import { useHotkeys } from "react-hotkeys-hook";
import { Button, InputNumber, Modal } from "antd";
import _ from "lodash";
import { rememberSelf, markActAs } from "src/utils/actAs";

const Layout = ({ children }) => {
  const { user, userDispatch, userType } = useUserContext();
  const refTn = useRef();
  const [modal, setModal] = useState(false);
  const [tn, setTn] = useState(null);

  useHotkeys("alt+t", () => {
    setModal(true);
    refTn.current.focus();
  });

  const changeUser = () => {
    if (tn) {
      API.changeUser({ tn: _.toString(tn) }).then((res) => {
        // ⚠ ӨӨРИЙН токеныг ЭХЛЭЭД аварна. `localStorage.clear()` нь
        //   sessionStorage-д хүрэхгүй тул буцах зам үлдэнэ (utils/actAs.js).
        //   Үүнгүйгээр хөгжүүлэгч буцахын тулд SSO-гоор дахин нэвтрэх
        //   шаардлагатай болдог байв.
        rememberSelf(user && user.tn);
        window.localStorage.clear();
        localStorage.setItem("token", res);
        markActAs(_.toString(tn));
        window.location.replace("/me");
      });
    }
  };

  return (
    <div className="page fadeIn animated">
      <Modal
        title={<div className="text-center">Өөр хэрэглэгчээр нэвтрэх</div>}
        open={modal}
        width={300}
        footer={false}
        centered
        onCancel={() => {
          setModal(false);
          setTn(null);
        }}
      >
        <div className="flex flex-col text-xs">
          <span className="font-bold mb-1">Бүртгэлийн дугаар:</span>
          <InputNumber
            ref={refTn}
            value={tn}
            onChange={(value) => setTn(value)}
            className="w-full"
            onPressEnter={() => changeUser()}
          />

          <Button
            className="mt-5 bg-primary text-white"
            onClick={() => changeUser()}
          >
            Нэвтрэх
          </Button>
        </div>
      </Modal>

      {user.template.showSidebar && (
        <div
          className="md:hidden absolute w-full min-h-screen bg-gray-700 opacity-50 z-10"
          onClick={() => {
            userDispatch({
              type: userType.CHANGE_SHOW_SIDEBAR,
              data: !user.template.showSidebar,
            });
          }}
        ></div>
      )}
      <Sidebar />
      <div className="main-content h-100">
        <Header />
        <div className="container-fluid">
          <Breadcrumb />
          {/* ⚠ Текстгүй товч — хуудас бүрийн дээд талд ~25px хоосон зай
              эзэлдэг байв (2026-09-26). Функц нь (`changeUser`) хэвээр
              тул устгалгүй НУУВ. */}
          <button
            type="button"
            onClick={() => changeUser()}
            style={{ display: "none" }}
          ></button>
          {children}
        </div>
      </div>

      {/* Дэлгэцийг дээш/доош гүйлгэх хөвөгч товч — бүх хуудсанд */}
      <ScrollButtons />
      <AssistantChat />
    </div>
  );
};

export default React.memo(Layout);
